import { render, staticRenderFns } from "./EditBoxBoolean.vue?vue&type=template&id=976cdf90&scoped=true&"
import script from "./EditBoxBoolean.vue?vue&type=script&lang=js&"
export * from "./EditBoxBoolean.vue?vue&type=script&lang=js&"
import style0 from "../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=976cdf90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976cdf90",
  null
  
)

export default component.exports